import React from 'react';
import styled from 'styled-components/macro';

import DatePickerHeader from '../DatePickerHeader';
import { StyledDateRange } from './DatePicker.styles';

function ReactDateRange({
  prefix,
  disabled,
  excludeDateIntervals,
  invalid,
  error,
  onChange,
  value,
  selectsRange = false, // ✅ control single or range mode
  ...props
}) {
  // Format display value to prevent formatting errors on partial ranges
  const getDisplayValue = () => {
    if (!selectsRange || !value) return '';
    if (selectsRange) {
      const [start, end] = value;
      if (!start) return '';
      if (start && !end)
        return new Date(start).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      if (start && end)
        return `${new Date(start).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })} - ${new Date(end).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}`;
    }
    if (!selectsRange) {
      return new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }
    return '';
  };

  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

  return (
    <StyledDateRange
      disabled={disabled}
      excludeDateIntervals={excludeDateIntervals}
      prefix={prefix}
      invalid={invalid || error}
      selectsRange={selectsRange} // ✅ dynamically enable range mode
      startDate={selectsRange && value?.[0] ? new Date(value[0]) : undefined}
      endDate={selectsRange && value?.[1] ? new Date(value[1]) : undefined}
      selected={!selectsRange && value ? new Date(value) : null}
      value={getDisplayValue() || undefined}
      dateFormat="MMM dd, yyyy"
      popperPlacement="bottom-start"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <DatePickerHeader
          date={date}
          changeYear={changeYear}
          changeMonth={changeMonth}
          decreaseMonth={decreaseMonth}
          increaseMonth={increaseMonth}
          prevMonthButtonDisabled={prevMonthButtonDisabled}
          nextMonthButtonDisabled={nextMonthButtonDisabled}
        />
      )}
      {...props}
      onChange={dates => {
        if (selectsRange) {
          // ✅ Handle range selection
          const [start, end] = dates || [];
          onChange({
            target: {
              value: [
                start ? (isoRegex.test(start) ? start : start?.toISOString()) : null,
                end ? (isoRegex.test(end) ? end : end?.toISOString()) : null,
              ],
              name: props.name,
            },
          });
        } else {
          // ✅ Handle single date
          const date = dates;
          onChange({
            target: {
              value: date ? date.toISOString() : null,
              name: props.name,
            },
          });
        }
      }}
    />
  );
}

export default ReactDateRange;
